(function () {
  const DEBUG = false;

  function placeErrorBelowButton() {
  const wrapper = document.querySelector('.quantity-submit-row__submit');
  if (!wrapper) return;

  const errorEl = wrapper.querySelector('.js-form-error[role="alert"]');
  // match both your rbr button and the theme button just in case
  const btn =
    wrapper.querySelector('button.add-to-cart.rbr') ||
    wrapper.querySelector('button.add-to-cart') ||
    wrapper.querySelector('button[name="add"][type="submit"]');

  if (!errorEl || !btn) return;

  // If error is not immediately after the button, move it there
  if (btn.nextElementSibling !== errorEl) {
    btn.insertAdjacentElement('afterend', errorEl);
  }
}

function initErrorPlacementWatcher() {
  // Initial attempt
  placeErrorBelowButton();

  // Keep it correct if the app re-renders the DOM
  const root =
    document.querySelector('#rbr-container-element-true') ||
    document.querySelector('.quantity-submit-row__submit') ||
    document.body;

  const obs = new MutationObserver(function () {
    placeErrorBelowButton();
  });

  obs.observe(root, { childList: true, subtree: true });

  // Also run after window load (sometimes the widget renders late)
  window.addEventListener('load', function () {
    placeErrorBelowButton();
  });
}




  const BUNDLE_CONTAINER_SELECTOR = '#rbr-container-element-true';
  const CART_ADD_MATCH = '/cart/add';

  const originalFetch = window.fetch;

  function dlog() {
    if (!DEBUG) return;
    // eslint-disable-next-line no-console
    console.log.apply(console, ['[Bundle Fix]'].concat([].slice.call(arguments)));
  }

  function showErrorNearButton(msg) {
    const el = document.querySelector('.quantity-submit-row__submit .js-form-error[role="alert"]');
    if (el) {
      el.textContent = msg;
      el.hidden = false;
    }
    placeErrorBelowButton(); 
  }

  function clearErrorNearButton() {
    const el = document.querySelector('.quantity-submit-row__submit .js-form-error[role="alert"]');
    if (el) {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function moveErrorBelowButton() {
  const wrapper = document.querySelector('.quantity-submit-row__submit');
  if (!wrapper) return;

  const errorEl = wrapper.querySelector('.js-form-error[role="alert"]');
  const btn = wrapper.querySelector('button.add-to-cart.rbr');

  if (errorEl && btn) {
    wrapper.appendChild(errorEl); // moves it to the bottom of wrapper
  }
  }

  function error422(msg) {
    // HTTP 422 helps prevent “success” toasts from other scripts
    // JSON body lets Saltyard set error text via data.status/description
    return new Response(
      JSON.stringify({
        status: 422,
        message: msg,
        description: msg,
        errors: { base: [msg] }
      }),
      {
        status: 422,
        statusText: 'Unprocessable Entity',
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }

  async function extractVariantIdAndQty(input, init) {
    try {
      // fetch(Request)
      if (input instanceof Request) {
        const cloned = input.clone();

        // Most reliable for multipart/form-data and urlencoded
        try {
          const fd = await cloned.formData();
          const id = fd.get('id');
          const quantity = fd.get('quantity');
          if (id && quantity) {
            return {
              variantId: parseInt(String(id), 10),
              qty: parseInt(String(quantity), 10)
            };
          }
        } catch (e) {
          // Fallback: text
          const text = await cloned.text();
          const t = (text || '').trim();
          if (!t) return null;

          if (t.charAt(0) === '{') {
            const obj = JSON.parse(t);
            if (obj.id && obj.quantity) {
              return {
                variantId: parseInt(String(obj.id), 10),
                qty: parseInt(String(obj.quantity), 10)
              };
            }
          } else {
            const obj2 = Object.fromEntries(new URLSearchParams(t).entries());
            if (obj2.id && obj2.quantity) {
              return {
                variantId: parseInt(String(obj2.id), 10),
                qty: parseInt(String(obj2.quantity), 10)
              };
            }
          }
        }

        return null;
      }

      // fetch(url, { body })
      if (init && 'body' in init) {
        const body = init.body;

        if (body instanceof FormData) {
          const id2 = body.get('id');
          const quantity2 = body.get('quantity');
          if (id2 && quantity2) {
            return { variantId: parseInt(String(id2), 10), qty: parseInt(String(quantity2), 10) };
          }
          return null;
        }

        if (body instanceof URLSearchParams) {
          const id3 = body.get('id');
          const quantity3 = body.get('quantity');
          if (id3 && quantity3) {
            return { variantId: parseInt(String(id3), 10), qty: parseInt(String(quantity3), 10) };
          }
          return null;
        }

        if (typeof body === 'string') {
          const t2 = body.trim();
          if (!t2) return null;

          if (t2.charAt(0) === '{') {
            const obj3 = JSON.parse(t2);
            if (obj3.id && obj3.quantity) {
              return { variantId: parseInt(String(obj3.id), 10), qty: parseInt(String(obj3.quantity), 10) };
            }
          } else {
            const obj4 = Object.fromEntries(new URLSearchParams(t2).entries());
            if (obj4.id && obj4.quantity) {
              return { variantId: parseInt(String(obj4.id), 10), qty: parseInt(String(obj4.quantity), 10) };
            }
          }
        }
      }
    } catch (e2) {
      dlog('extractVariantIdAndQty error:', e2);
    }

    return null;
  }

  async function getVariantInfo(variantId) {
    // Use originalFetch to avoid recursion
    const res = await originalFetch('/variants/' + String(variantId) + '.js', {
      credentials: 'same-origin'
    });
    if (!res.ok) return { inv: null, title: '' };

    const v = await res.json();
    return {
      inv: (typeof v.inventory_quantity === 'number') ? v.inventory_quantity : null,
      title: v.public_title || v.title || ''
    };
  }

  async function rollbackVariantFromCart(variantId) {
    const payload = { updates: {} };
    payload.updates[String(variantId)] = 0;

    const res = await originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });

    dlog('Rollback /cart/update.js status:', res.status);
    return res.ok;
  }

  function getUrlString(input) {
    return (typeof input === 'string') ? input : (input && input.url ? input.url : '');
  }

  function getMethod(input, init) {
    if (init && init.method) return String(init.method).toUpperCase();
    if (input instanceof Request && input.method) return String(input.method).toUpperCase();
    return 'GET';
  }

  window.fetch = async function (input, init) {
    const url = getUrlString(input);
    const method = getMethod(input, init);

    const isCartAdd = url && url.indexOf(CART_ADD_MATCH) !== -1;
    const inBundleContext = !!document.querySelector(BUNDLE_CONTAINER_SELECTOR);

    // ---- PRE-FLIGHT HARD BLOCK (prevents Shopify partial add) ----
    if (isCartAdd && inBundleContext && method === 'POST') {
      clearErrorNearButton();

      const attempt = await extractVariantIdAndQty(input, init);
      dlog('Preflight attempt:', attempt);

      if (attempt && attempt.variantId && attempt.qty) {
        const info = await getVariantInfo(attempt.variantId);
        dlog('Inventory check:', {
          inv: info.inv,
          qty: attempt.qty,
          variantId: attempt.variantId,
          title: info.title
        });

        if (info.inv !== null && attempt.qty > info.inv) {
          const variantLabel = info.title ? (' (' + info.title + ')') : '';
          const msg =
            'Only ' + String(info.inv) +
            ' available for your selected option' + variantLabel +
            '. Please choose different sizes/colors so you can add all 5.';

          // show it near the button too
          showErrorNearButton(msg);

          dlog('Blocking BEFORE Shopify (returning 422):', msg);
          return error422(msg);
        }
      }
      // If we can't parse or inv isn't trackable -> fail open
    }

    // ---- NORMAL REQUEST ----
    const res = await originalFetch.apply(this, arguments);

    // ---- SAFETY NET: if Shopify still returns 422 (race condition), rollback the partial add ----
    try {
      if (isCartAdd && inBundleContext && res.status === 422) {
        const attempt2 = await extractVariantIdAndQty(input, init);
        dlog('Shopify 422; attempt for rollback:', attempt2);

        // Rollback anything Shopify partially added
        if (attempt2 && attempt2.variantId) {
          await rollbackVariantFromCart(attempt2.variantId);
        }

        // Build a more specific message here too
        let msg2 = 'Not enough stock for that selection. Please choose different sizes/colors so you can add all 5.';

        if (attempt2 && attempt2.variantId) {
          const info2 = await getVariantInfo(attempt2.variantId);
          const variantLabel2 = info2.title ? (' (' + info2.title + ')') : '';
          if (info2.inv !== null) {
            msg2 =
              'Only ' + String(info2.inv) +
              ' available for your selected option' + variantLabel2 +
              '. Please choose different sizes/colors so you can add all 5.';
          } else if (info2.title) {
            msg2 =
              'Not enough stock for your selected option' + variantLabel2 +
              '. Please choose different sizes/colors so you can add all 5.';
          }
        }

        showErrorNearButton(msg2);
        return error422(msg2);
      }
    } catch (e3) {
      dlog('422 rollback handler error:', e3);
    }

    return res;
  };

  moveErrorBelowButton();

initErrorPlacementWatcher();

  dlog('Bundle Fix loaded (variant-aware messages in both branches).');
})();
